export const CONTACTTYPE_SHOW_RESET = 'CONTACTTYPE_SHOW_RESET'
export const CONTACTTYPE_SHOW_SET_ERROR = 'CONTACTTYPE_SHOW_SET_ERROR'
export const CONTACTTYPE_SHOW_SET_RETRIEVED = 'CONTACTTYPE_SHOW_SET_RETRIEVED'
export const CONTACTTYPE_SHOW_TOGGLE_LOADING = 'CONTACTTYPE_SHOW_TOGGLE_LOADING'



// WEBPACK FOOTER //
// ./src/store/modules/contact_type/show/mutation_types.js